import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { ReportFilterFamilyKey, StudiesFilterMode } from './types';

export const STUDY_TYPE_TO_LABEL: Record<string, string> = {
  [StudyType.StudyType_CBCT.toString()]: 'cbct',
  [StudyType.StudyType_IntraoralXRay.toString()]: 'ioxray',
  [StudyType.StudyType_PanoramicXRay.toString()]: 'pano',
  [StudyType.StudyType_IOS_Meshes.toString()]: 'ios',
  [StudyType.StudyType_DentalPhoto.toString()]: 'dental_photo',
};

export const TRANSCRIPTOR_FILTER_VALUE = 'transcriptor';

export const STUDIES_FILTER_MODES: StudiesFilterMode[] = ['studies', 'reports'];

/**
 * Reports mode options are product families, not raw `ReportType` values: one
 * checkbox covers every report type a user knows under that product name.
 * Keys are stable identifiers used in the `reportTypes` URL param and analytics.
 */
/**
 * Dental photos are uploaded studies, not reports: the product never creates
 * `DentalPhoto_GP` reports, so this family is sent as `StudyType_DentalPhoto`
 * in the study-type filter instead of report types.
 */
export const DENTAL_PHOTOS_FILTER_FAMILY = 'dentalPhotos';

export const REPORT_FILTER_FAMILY_KEYS = [
  'cbct',
  'ioxray',
  'pano',
  '3dModel',
  'superimposition',
  'implant',
  'ortho',
  DENTAL_PHOTOS_FILTER_FAMILY,
] as const;

export const REPORT_FILTER_FAMILIES: Record<
  ReportFilterFamilyKey,
  readonly ReportType[]
> = {
  cbct: [ReportType.ReportType_CBCT_GP],
  ioxray: [
    ReportType.ReportType_IOXRay_GP,
    ReportType.ReportType_Pano_Bitewings,
  ],
  pano: [ReportType.ReportType_Pano_GP],
  '3dModel': [
    ReportType.ReportType_CBCT_Segmentation,
    ReportType.ReportType_IOS_Segmentation,
  ],
  superimposition: [ReportType.ReportType_CBCT_IOS_Superimposition],
  implant: [
    ReportType.ReportType_StudioImplant,
    ReportType.ReportType_CBCT_Implant,
  ],
  ortho: [
    ReportType.ReportType_StudioOrtho,
    ReportType.ReportType_CBCT_OrthoSlides,
  ],
  [DENTAL_PHOTOS_FILTER_FAMILY]: [],
};
